import axios from "axios";
import React, { useEffect, useState } from "react";
import styles from "./PennyDrop.module.css";
import { useNavigate } from "react-router";
import { ToastContainer, toast } from "react-toastify";
import { useBorrowerContext } from "../../../../../../store/borrower-details";
import { url } from "../../../../../../../../../App";
import Cookies from 'js-cookie';

const PennyDrop = ({ openLoader, closeLoader }) => {
  const Navigate = useNavigate();
  const { borrowerData } = useBorrowerContext();

  const [pennyDropDone, setpennyDropDone] = useState(false);
  const [pennydropData, setpennydropData] = useState({
    accountStatus: "",
    message: "",
    data: {},
  });

  const [verified, setVerified] = useState(0);
  const fetchPennyDrop = async () => {
    openLoader();
    try {
      const request = {
        borrower_uniqueno: localStorage.getItem("uniqueID"),
        email: Cookies.get('Email'),
        token: Cookies.get('Token'),
      };

      const { data: response } = await axios.post(
        url + "/verification/pennydropdetails",
        request
      );
      if (!response.auth) {
        setpennydropData((prevState) => ({
          ...prevState,
          accountStatus: response.account_status,
          message: response.message,
          data: response.data,
        }));
        if (response.logout) {
          Navigate("/");
        }
        return;
      }
      setpennyDropDone(true);
      setpennydropData((prevState) => ({
        ...prevState,
        accountStatus: response.account_status,
        message: response.message,
        data: response.data,
      }));
    } catch (err) {
      console.log(err);
    } finally {
      closeLoader();
    }
  };
  useEffect(() => {
    fetchPennyDrop();
    //eslint-disable-next-line
  }, [verified]);

  const verifyPennydrop = async () => {
    openLoader();
    try {
      const request = {
        borrower_uniqueno: localStorage.getItem("uniqueID"),
        email: Cookies.get('Email'),
        token: Cookies.get('Token'),
      };
      const { data: response } = await axios.post(
        url + "/verification/pennydrop",
        request
      );
      if (!response.auth) {
        toast.error(response.message);
        if (response.logout) {
          setTimeout(() => {
            Navigate("/");
          }, 2000);
        }
        return;
      }
      setVerified((prevState) => prevState + 1);
      toast.success(response.message);
      // window.location.reload();
      //   console.log(response)
    } catch (err) {
      console.log(err);
      toast.error(err.message);
    } finally {
      closeLoader();
    }
  };
  return (
    <>
      <ToastContainer />
      <div>
        <div className={styles.pennydropStatus}>
          <p>Account Status: {pennydropData?.accountStatus}</p>
          <p>Note: {pennydropData?.message}</p>
        </div>
        <hr className={styles.hr} style={{ marginTop: "1vh" }} />
        <div className={styles.verifyButton}>
          <button onClick={verifyPennydrop}>
            {pennyDropDone ? `Reverify Pennydrop` : "Verify Pennydrop"}
          </button>
        </div>

        <div className={styles.pennydropContainer}>
          {
            <>
              <div className={styles.pennydropItem}>
                <p>Benificiary Name: </p>
                <p>{pennydropData?.data?.nameAtBank}</p>
              </div>
              <div className={styles.pennydropItem}>
                <p>Bank name: </p>
                <p>{pennydropData?.data?.bankName}</p>
              </div>
              <div className={styles.pennydropItem}>
                <p>City: </p>
                <p>{pennydropData?.data?.city}</p>
              </div>
              <div className={styles.pennydropItem}>
                <p>Branch: </p>
                <p>{pennydropData?.data?.branch}</p>
              </div>
              <div className={styles.pennydropItem}>
                <p>IFSC Code: </p>
                <p>{borrowerData.borrower.borrower_collection_bank_ifsc}</p>
              </div>
              <div className={styles.pennydropItem}>
                <p>Account Number: </p>
                <p>
                  {borrowerData.borrower.borrower_disbursement_bank_account}
                </p>
              </div>
            </>
          }
        </div>
      </div>
    </>
  );
};

export default PennyDrop;
